// Area: view-layouts (owner views-layouts, wave 2, plan §9.23). The manual card order of a board
// (`view_record_rank`): a dropped card is ranked between its new neighbours. Boards read the order
// through `POST /objects/:key/query` with `rankedBy: <view id>`.
import { RankMoveInput, RankMoveResult } from '@dataroom/core/view-layouts';
import { z } from 'zod';
import { defineContract } from '../define';

export { RankMoveInput, RankMoveResult };

const KeyView = z.object({ key: z.string().min(1).max(63), view: z.string().min(1).max(80) });

export const moveCardRankContract = defineContract({
  method: 'POST',
  path: '/objects/:key/views/:view/ranks',
  params: KeyView,
  body: RankMoveInput,
  response: RankMoveResult,
  permission: 'records.read',
  summary:
    'Place a card in the manual order of a board view (the member must see the view and may edit the record)',
});
